<template>
  <section class="section">
    <div class="container">
      <div class="mb-8">
        <div class="title is-4 has-text-primary uppercase mb-4">
          2/3 - Choix de la baie ou du coffret
        </div>
        <b-button
          type="is-text"
          class="button-bold"
          tag="router-link"
          :to="getConfigurationPath()"
        >
          Revenir à la configuration
        </b-button>
      </div>

      <div
        v-if="container && !isContainerAdequate(container)"
      >
        <BaseNotice>
          <p class="has-text-danger">
            Vous avez modifié le contenu de votre configuration
            veuillez choisir une baie ou un coffret en adéquation avec votre sélection produits.
          </p>
        </BaseNotice>
      </div>
      <div
        v-else-if="hasInadequateContainers"
      >
        <BaseNotice icon-class="has-text-info">
          <p class="has-text-info">
            Nous avons restreint la selection aux coffret(s) et baie(s) compatibles avec la
            taille de votre configuration (hauteur et profondeur).
          </p>
        </BaseNotice>
      </div>

      <b-field label="Type">
        <b-select
          :value="filters.type"
          class="primary-borders border-l-4"
          @input="selectType"
        >
          <option>
            Baie
          </option>
          <option>
            Coffret
          </option>
        </b-select>
      </b-field>
      <ProductFilters />
      <div class="w-full flex-1 box overflow-y-auto bg-gray">
        <div
          v-for="product in displayedProducts"
          :key="product.id"
          class="columns card mb-8 mx-0"
        >
          <BaseCard
            :card-title="product.designation"
            :text-lines="productTextAttributes(product)"
            :image-url="product.photo_url"
            :class="{ border: productQuantityText(product) }"
            class="w-full"
          >
            <div class="flex">
              <b-button
                v-if="getQuantityByProduct(product)"
                type="is-danger"
                icon-left="trash"
                class="mr-2"
                outlined
                @click="resetProductQuantity(product)"
              />
              <p class="control">
                <b-button
                  v-if="!getQuantityByProduct(product)"
                  type="is-primary"
                  native-type="submit"
                  @click="chooseContainer(product)"
                >
                  {{ chooseContainerText }}
                </b-button>
              </p>
            </div>
          </BaseCard>
        </div>
      </div>
    </div>
    <b-navbar
      fixed-bottom
      class="pr-4"
    >
      <template
        slot="end"
      >
        <b-button
          v-if="container && isContainerAdequate(container)"
          type="is-success"
          tag="router-link"
          :to="getConfigurationPath('/resume')"
        >
          Continuer
        </b-button>
      </template>
    </b-navbar>
  </section>
</template>

<script>
import BaseCard from '@/components/BaseCard.vue';
import BaseNotice from '@/components/BaseNotice.vue';
import { mapGetters, mapState } from 'vuex';
import { filter } from 'lodash';
import { BAIE } from '../constants';
import configurationMixin from './mixins/configurationMixin';
import containerChoiceMixin from './mixins/containerChoiceMixin';
import ProductFilters from './partials/ProductFilters.vue';

export default {
  name: 'ContainerChoice',
  components: { ProductFilters, BaseCard, BaseNotice },
  mixins: [configurationMixin, containerChoiceMixin],
  computed: {
    ...mapGetters('configuration', ['container', 'containers',
      'isContainerAdequate', 'configurationSize', 'containersSize']),
    ...mapState('configuration', ['filters']),
    containerProducts() {
      return this.sortedProducts || this.filteredProducts;
    },
    displayedProducts() {
      return filter(this.containerProducts, this.isContainerAdequate);
    },
    hasInadequateContainers() {
      return this.containerProducts.length !== this.displayedProducts.length;
    },
    chooseContainerText() {
      if (this.container) {
        return 'Remplacer';
      }
      return 'Choisir';
    },
  },
  mounted() {
    if (this.containers[0]) {
      this.selectType(this.containers[0].productable_type);
    } else {
      this.selectType(BAIE);
    }
  },
};
</script>
